export default __webpack_public_path__ + "static/media/json-icon.40c9e908.svg";